import {CbEntityRecordDocumentationService} from "./service/api/cb-entity-record-documentation.service";
import {ENTITY_SERVICE_REGISTRY, EntityServiceEntry} from "../../core/shared/dto/dto-service/entity-service-registry";

export const CB_ENTITY_PROVIDER = [
    {
        provide: ENTITY_SERVICE_REGISTRY,
        useValue: [
            ['cb.CbDomainConcept', {route: '/cb/cbDomainConcepts'}],
            ['cb.CbSynonym', {route: '/cb/cbSynonyms'}],
            ['cb.CbBusinessRule', {route: '/cb/cbBusinessRules'}],
            ['cb.CbQueryTemplate', {route: '/cb/cbQueryTemplates'}],
            ['cb.CbQueryTemplateParameter', {route: '/cb/cbQueryTemplateParameters'}],
            ['cb.CbQueryLog', {route: '/cb/cbQueryLogs'}],
            ['cb.CbQueryFeedback', {route: '/cb/cbQueryFeedbacks'}],
            ['cb.CbTrainingData', {route: '/cb/cbTrainingDatas'}],
            ['cb.CbModelVersion', {route: '/cb/cbModelVersions'}],
            ['cb.CbCoverageMetric', {route: '/cb/cbCoverageMetrics'}],
            ['cb.CbConversationSession', {route: '/cb/cbConversationSessions'}],
            ['cb.CbConversationTurn', {route: '/cb/cbConversationTurns'}],
            ['cb.CbKnowledgeCategory', {route: '/cb/knowledgeCategories'}],
            ['cb.CbEntityRecordDocumentation', {route: '/cb/entityRecordDocumentations', service: CbEntityRecordDocumentationService}],
            ['cb.CbMetaModule', {route: '/cb/cbMetaModules'}],
            ['cb.CbMetaEntity', {route: '/cb/cbMetaEntities'}],
            ['cb.CbMetaEntityAttribute', {route: '/cb/cbMetaEntityAttributes'}],
            ['cb.CbMetaEnumValue', {route: '/cb/cbMetaEnumValues'}],
            ['cb.CbMetaEntityFilter', {route: '/cb/cbMetaEntityFilters'}],
            ['cb.CbDeclaration', {route: '/cb/cbDeclarations'}],
            // TODO: Help entities (CbHelpCategory, CbHelpSuggestedQuestion, CbHelpGlossaryTerm,
            // CbHelpTour, CbHelpAiConfig, CbHelpContextMapping) need ObjectCrudController
            // backend implementation before they can be registered here.
        ] as EntityServiceEntry[],
        multi: true
    }
];
